/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./okxWallet.vue?vue&type=template&id=298c525b&scoped=true"
import script from "./okxWallet.vue?vue&type=script&lang=js"
export * from "./okxWallet.vue?vue&type=script&lang=js"
import style1 from "./okxWallet.vue?vue&type=style&index=1&id=298c525b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298c525b",
  null
  
)

export default component.exports